import "@livekit/components-styles";

import {
  LiveKitRoom,
  RoomAudioRenderer,
  VideoConference,
} from "@livekit/components-react";

import type { CallPayload } from "@/lib/support";

type Props = {
  call: CallPayload;
  onLeave: () => void;
};

/**
 * A 1:1 live support call. Reuses LiveKit's batteries-included
 * <VideoConference>, whose control bar already exposes camera / mic /
 * **screen-share** toggles — so both the agent and the customer can share
 * their screen with zero extra wiring.
 */
export function SupportCallRoom({ call, onLeave }: Props) {
  return (
    <div className="fixed inset-0 z-50 bg-black">
      <LiveKitRoom
        token={call.token}
        serverUrl={call.url}
        connect
        video
        audio
        onDisconnected={onLeave}
        data-lk-theme="default"
        style={{ height: "100%" }}
      >
        <VideoConference />
        <RoomAudioRenderer />
      </LiveKitRoom>
    </div>
  );
}
